var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"crop-image-preview",style:(_vm.containerStyle)},[(_vm.imageSrc)?_c('img',{staticClass:"crop-image-preview__img",attrs:{"src":_vm.imageSrc}}):_c('div',{staticClass:"crop-image-preview__placeholder"},[_vm._v("Нет изображения")])])
}
var staticRenderFns = []

export { render, staticRenderFns }